import React from "react";
import Body from "./Body";

const UniversalSheet = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default UniversalSheet;
